import { CompletionPane } from '@datacamp/le-shared-components';
import React from 'react';
import { Instructions } from './Instructions';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const InstructionPane = _ref => {
  let {
    assignment,
    children,
    className,
    completionPaneVisible,
    customAssignmentItem,
    customInstructionsHeader,
    disableStickyHeadings,
    enableResources,
    exerciseId,
    exerciseSubtitle,
    feedbackMessages,
    footer,
    hideTakeHint,
    hintCost,
    hintShown,
    instructionSubtitle,
    isCloudExercise,
    isRatingPermitted,
    maxTimesToShowSolution,
    onClickCollapse,
    onCloseCompletionPane,
    onContinue,
    onRate,
    onRateFeedback,
    onTakeHint,
    onTakeSolution,
    padBottom,
    remainingXp,
    resources,
    solutionShown,
    successMessage,
    title
  } = _ref;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Instructions, {
    assignment: assignment,
    className: className,
    customAssignmentItem: customAssignmentItem,
    customInstructionsHeader: customInstructionsHeader,
    disableStickyHeadings: disableStickyHeadings,
    enableResources: enableResources,
    exerciseId: exerciseId,
    exerciseSubtitle: exerciseSubtitle,
    feedbackMessages: feedbackMessages,
    footer: footer,
    hideTakeHint: hideTakeHint,
    hintCost: hintCost,
    hintShown: hintShown,
    instructionSubtitle: instructionSubtitle,
    isCloudExercise: isCloudExercise,
    maxTimesToShowSolution: maxTimesToShowSolution,
    onClickCollapse: onClickCollapse,
    onRateFeedback: onRateFeedback,
    onTakeHint: onTakeHint,
    onTakeSolution: onTakeSolution,
    padBottom: padBottom,
    remainingXp: remainingXp,
    resources: resources,
    solutionShown: solutionShown,
    title: title
  }, children), completionPaneVisible && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(CompletionPane, {
    message: successMessage,
    onClose: onCloseCompletionPane,
    onContinue: onContinue,
    onRate: isRatingPermitted ? onRate : undefined,
    xp: remainingXp
  })));
};